import { jsx as _jsx } from "react/jsx-runtime";
import SpotlightCarouselCard from '@/components/molecules/SpotlightCarouselCard/SpotlightCarouselCard';
import clsx from 'clsx';
const SpotlightCarouselSlideWrapper = ({ item, isActive, accessibilityProps, isModalEnabled, onOpenModal, captionPlacement, className, }) => {
    const Element = isModalEnabled ? 'button' : 'div';
    return (_jsx(Element, { className: clsx(isModalEnabled && 'cursor-pointer', 'block w-full', className), onClick: () => {
            if (isModalEnabled) {
                onOpenModal();
            }
        }, "aria-label": isModalEnabled ? item.ariaLabel : undefined, "aria-haspopup": isModalEnabled ? 'dialog' : undefined, ...accessibilityProps, children: _jsx(SpotlightCarouselCard, { ...item, captionPlacement: captionPlacement, captionBelowVisible: isActive }) }));
};
export default SpotlightCarouselSlideWrapper;
